module.exports = __webpack_public_path__ + "static/approach-2412e72a9974f13f38deab99991c2ac4.jpg";